import { saveUserInformation } from "@utils/storage";
import { getPayload } from "@mappers/postProspectMapper";
import { useFetch } from "./useFetch";
import { CREATE_PROSPECT_ROUTE } from "@api-routes/acquisitionProspects";

export const useCreateProspect = () => {
    const [createProspectState, { post }] = useFetch();

    const callCreateProspect = () => {
        return post<string>(CREATE_PROSPECT_ROUTE, { body: getPayload() }).then((prospectReference) => {
            if (prospectReference) {
                saveUserInformation(prospectReference);

                return prospectReference;
            }

            return undefined;
        });
    };

    return { callCreateProspect, createProspectState };
};
